/* Native modal viewer. Uses the already-rendered photo; never alters artwork. */
(() => {
  'use strict';
  if (window.stEngravingExpand) return;
  let dialog, image, viewport, zoom, baseWidth, activeCanvas;
  function resize() {
    if (!dialog?.open || !activeCanvas) return;
    baseWidth = Math.min(viewport.clientWidth - 16, (viewport.clientHeight - 16) * activeCanvas.width / activeCanvas.height);
    image.style.width = `${Math.max(1, baseWidth * Number(zoom.value))}px`;
  }
  function open(canvas) {
    const src = canvas.toDataURL('image/png');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'st-eng-expand';
      dialog.setAttribute('aria-labelledby', 'st-eng-expand-title');
      dialog.innerHTML = '<div class="st-eng-expand__bar"><h2 id="st-eng-expand-title">Engraving photo preview</h2><button type="button" data-close aria-label="Close expanded preview">Close</button></div>' +
        '<div class="st-eng-expand__tools"><label>Zoom <select data-zoom><option value="1">Fit</option><option value="1.5">150%</option><option value="2">200%</option><option value="3">300%</option></select></label><span>Scroll or swipe to inspect the enlarged photo.</span></div>' +
        '<div class="st-eng-expand__viewport" tabindex="0" aria-label="Scrollable engraving photo"><img alt="" draggable="false"></div>';
      document.body.append(dialog);
      image = dialog.querySelector('img');
      viewport = dialog.querySelector('.st-eng-expand__viewport');
      zoom = dialog.querySelector('[data-zoom]');
      dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => { image.removeAttribute('src'); activeCanvas = null; });
      zoom.addEventListener('change', () => { resize(); viewport.scrollTo(0, 0); });
      window.addEventListener('resize', resize);
    }
    activeCanvas = canvas;
    image.src = src;
    image.alt = canvas.getAttribute('aria-label') || 'Expanded engraving photo preview';
    zoom.value = '1';
    if (!dialog.open) dialog.showModal();
    resize();
    viewport.scrollTo(0, 0);
    dialog.querySelector('[data-close]').focus();
  }
  window.stEngravingExpand = {open};
})();